document.addEventListener("DOMContentLoaded", function () {
  // Tab functionality
  const tabs = document.querySelectorAll(".tab-btn");
  const contents = document.querySelectorAll(".tab-content");

  function setActiveTab(tabId) {
    tabs.forEach((t) => t.classList.remove("active"));
    contents.forEach((c) => c.classList.remove("active"));
    const activeTab = document.querySelector(`.tab-btn[data-tab="${tabId}"]`);
    const activeContent = document.getElementById(tabId);
    if (activeTab && activeContent) {
      activeTab.classList.add("active");
      activeContent.classList.add("active");
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      setActiveTab(tab.dataset.tab);
    });
  });

  // Collapsible functionality (mobile)
  function toggleCollapsible(collapsible) {
    const content = collapsible.nextElementSibling;
    collapsible.classList.toggle("active");
    content.classList.toggle("active");
  }

  document.querySelectorAll(".collapsible").forEach((coll) => {
    coll.addEventListener("click", () => toggleCollapsible(coll));
  });

  function initializeCollapsibles() {
    if (window.innerWidth <= 727) {
      // Ensure all collapsibles are ready for mobile
      document.querySelectorAll(".collapsible").forEach((coll) => {
        coll.style.cursor = "pointer";
      });
      // Open the default active collapsible (Product Description)
      const activeTab = document.querySelector(".tab-btn.active");
      if (activeTab) {
        const activeCollapsible = document.querySelector(
          `.collapsible[data-tab="${activeTab.dataset.tab}"]`
        );
        if (activeCollapsible) {
          toggleCollapsible(activeCollapsible);
        }
      }
    } else {
      // Reset all collapsibles in desktop view
      document.querySelectorAll(".collapsible, .tab-content").forEach((el) => {
        el.classList.remove("active");
      });
      // Set the default active tab based on the HTML structure
      const defaultActiveTab = document.querySelector(".tab-btn.active");
      if (defaultActiveTab) {
        setActiveTab(defaultActiveTab.dataset.tab);
      }
    }
  }

  // Run on load
  initializeCollapsibles();

  // Run when resizing the window
  window.addEventListener("resize", initializeCollapsibles);

  // FAQ functionality
  document.querySelectorAll(".faq-question").forEach((question) => {
    question.addEventListener("click", () => {
      const answer = question.nextElementSibling;
      answer.classList.toggle("active");
    });
  });

  // Add structured data
  function addStructuredData() {
    const productJson = document.getElementById("ProductJson-{{ section.id }}");
    if (!productJson) return;

    const product = JSON.parse(productJson.textContent);
    const productVariant = product.selected_or_first_available_variant;
    const structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: product.title,
      image: [
        product.featured_image
          ? `${window.location.origin}${product.featured_image}`
          : "",
      ],
      description: product.description,
      sku: productVariant.sku,
      mpn: productVariant.barcode,
      brand: {
        "@type": "Brand",
        name: product.vendor,
      },
      offers: {
        "@type": "Offer",
        url: window.location.href,
        priceCurrency: window.shop.currency,
        price: productVariant.price / 100,
        availability: productVariant.available
          ? "https://schema.org/InStock"
          : "https://schema.org/OutOfStock",
        priceValidUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 1)
        )
          .toISOString()
          .split("T")[0],
      },
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);
  }

  // Call the function to add structured data
  addStructuredData();
});
